export default "__VITE_PUBLIC_ASSET__0ebe90a7__"